import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainPermissionGuard } from '../../_shared/guards/main-permission-guard.service';
import { ChangelogListComponent } from './changelog-list/changelog-list.component';

const routes: Routes = [
  {
    path:     'changelog',
    children: [
      {path: '', canActivate: [MainPermissionGuard], component: ChangelogListComponent},
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class ChangelogRoutingModule {
}
